<template>
<div class="features-labels">
  <div class="hero-overflow-wrap">
    <FeaturesHero
    title="One link"
    title-grey="All your Demo submissions"
    :background-image="require('@/assets/img/features/HeroDemos.webp')"
    :background-image-mobile="require('@/assets/img/features/HeroDemos-mob.webp')"
  />
  </div>

  <div class="inner-content d-f fd-c">
    <ColText3
      title-html="Demo inboxes are broken"
      :columns="problemColumns"
    />
    <Col6BigImg
      title-html="One place <span class='title-grey'>for every demo</span>"
      :cutout-image="require('@/assets/img/features/one-place-cutout.webp')"
      cutout-image-alt="Demo inbox on device"
      right-title="The solution"
      right-paragraph="Algorhythm gives labels a structured, collaborative inbox designed for modern A&R teams."
      :checklist="solutionChecklist"
      :imageBgColor="'var(--bg-color)'"
    />
    <ScrollAccordions
      :items="scrollAccordionItems"
      aria-label="How demos flow from artist to charts"
      :image-bg-color="'var(--bg-color)'"
    />
    <Col6BigReviewers
      title-html="<span class='title-grey'>Reviewer accounts for your</span> whole team"
      section-title="Who's reviewing?"
      show-add-card
      manage-profiles-text="Manage profiles"
      right-title="Key differentiator"
      right-paragraph="Algorhythm invites A&Rs, interns, and guest curators to review demos together. Track who listened, who voted, and who discovered the track first."
      :imageBgColor="'var(--bg-color)'"
    />
    <!-- <Col3Demo
      title-html="<span class='title-grey'>Three ways</span> demos flow into your inbox"
      :imageBgColor="'var(--bg-color)'"
    /> -->
    <Col3ImgText
      title-html="<span class='title-grey'>Demo reviews that</span> actually work"
      :columns="demoReviewsThatWork"
      :imageBgColor="'var(--bg-color)'"
    />
    <!-- <Col3ImgText
      title-html="<span class='title-grey'>Discover artists</span> before they break"
      :columns="demoReviewColumns"
      :alignImageBottom="true"
      :imageBgColor="'var(--bg-color)'"
    /> -->
    <!-- <Col6BigImg
      title-html="<span class='title-grey'>Discover artists</span> before they break"
      :cutout-image="require('@/assets/img/features/CutoutImage.png')"
      cutout-image-alt="Demo inbox on device"
      right-title="Key differentiator"
      right-paragraph="Algorhythm surfaces artists gaining traction in their local scenes.<br><br>Labels can track emerging talent across cities worldwide. Go beyond the inbox — find your next signing before the rest of the industry."
      :imageBgColor="'var(--bg-color)'"
    /> -->
    <Col6BigImg
      title-html="<span class='title-grey'>Discover artists</span> before they break"
      :cutout-image="require('@/assets/img/features/Ranking-desktop.webp')"
      :cutout-image-mobile="require('@/assets/img/features/Ranking-mobile.webp')"
      cutout-image-alt="Demo inbox on device"
      right-title="Discovery"
      right-paragraph="Algorhythm surfaces artists gaining traction in their local scenes.<br><br>Labels can track emerging talent across cities worldwide. Go beyond the inbox — find your next signing before the rest of the industry."
      :imageBgColor="'var(--bg-color)'"
    />
    <Col6BigImg
      title-html="Genre specific <span class='title-grey'>Track rankings</span>"
      :cutout-image="require('@/assets/img/features/Tracks-Electro.webp')"
      :cutout-image-mobile="require('@/assets/img/features/Tracks-Electro-mob.webp')"
      cutout-image-alt="Demo inbox on device"
      right-title="Charting"
      right-paragraph="By categorizing our library into granular sub-genres, we provide users with localized charts specific to their musical preferences. The ranking algorithm weighs plays, skips, and shares to provide an authentic reflection of trending status within individual musical communities, rather than relying solely on global stream counts."
      :imageBgColor="'var(--bg-color)'"
    />
  </div>
</div>
</template>
<script>
import FeaturesHero from '@/components/features/FeaturesHero.vue'
import ColText3 from '@/components/features/3ColText.vue'
import Col6BigImg from '@/components/features/Col6BigImg.vue'
import Col6BigReviewers from '@/components/features/Col6BigReviewers.vue'
import Col3Demo from '@/components/features/Col3Demo.vue'
import Col3ImgText from '@/components/features/Col3ImgText.vue'
import ScrollAccordions from '@/components/features/ScrollAccordions.vue'

export default {
  name: 'FeaturesLabels',
  components: {
    FeaturesHero,
    ColText3,
    Col6BigImg,
    Col6BigReviewers,
    Col3Demo,
    Col3ImgText,
    ScrollAccordions,
  },
  data() {
    return {
      scrollAccordionItems: [
        {
          title: 'Artist submits',
          description:
            'Artists use your one link—demos land in Algorhythm as structured submissions, not lost SoundCloud DMs or stray email attachments.',
          image: require('@/assets/img/features/steps/artist-submits.webp'),
          imageMob: require('@/assets/img/features/steps/artist-submits-mob.webp'),
          imageAlt: 'Artist submitting a demo',
        },
        {
          title: 'Inbox receives',
          description:
            'Every drop hits the same collaborative inbox: searchable, time-ordered, and ready for your team—no more threads across three tools.',
          image: require('@/assets/img/features/steps/inbox-receives.webp'),
          imageMob: require('@/assets/img/features/steps/inbox-receives-mob.webp'),
          imageAlt: 'Centralized demo inbox',
        },
        {
          title: 'Team listens',
          description:
            'Everyone hits the same queue—A&Rs, interns, and guests listen with shared ratings and comments so feedback stays aligned on every track.',
          image: require('@/assets/img/features/steps/team-listens.webp'),
          imageMob: require('@/assets/img/features/steps/team-listens-mob.webp'),
          imageAlt: 'Team reviewing demos',
        },
        {
          title: 'Feedback loop',
          description:
            'Listen, rate, comment, and decide in one place. Everyone sees the same track, the same history, and the same verdict—no crossed wires.',
          image: require('@/assets/img/features/steps/feedback-loop.webp'),
          imageMob: require('@/assets/img/features/steps/feedback-loop-mob.webp'),
          imageAlt: 'Demo feedback and engagement',
        },
        {
          title: 'Next steps',
          description:
            'Turn strong demos into real relationships—not just a rating. Your team can follow up with the artists who fit, keep momentum in one thread, and move talent from the inbox toward signings and releases with the same context everyone already shared.',
          image: require('@/assets/img/features/steps/next-steps.webp'),
          imageMob: require('@/assets/img/features/steps/next-steps-mob.webp'),
          imageAlt: 'Track and artist rankings',
        },
      ],
      demoReviewColumns: [
        {
          image: require('@/assets/img/features/CutoutImage2.png'),
          imageAlt: 'Ranking screen',
          heading: 'Receive submissions',
          body: 'Music rises because it deserves to. Become #1 in your neighborhood. Compete with artists around you and lead your local charts.',
          checklist: [],
        },
        {
          image: require('@/assets/img/features/CutoutImage2.png'),
          imageAlt: 'Review workflow',
          heading: 'Review together',
          body: 'Your team sees the same inbox. Rate, comment, and decide in one place—no more scattered feedback.',
          checklist: [],
        },
        {
          image: require('@/assets/img/features/CutoutImage2.png'),
          imageAlt: 'Analytics',
          heading: 'See what stands out',
          body: 'Ratings and signals show which demos resonate. Stop flying blind and focus on the best music.',
          checklist: [],
        },
      ],
      demoReviewsThatWork: [
        {
          image: require('@/assets/img/features/demo-reviews/Drop.webp'),
          imageAlt: 'Ranking screen',
          heading: 'Easy Demo Drop',
          body: 'Artists submit demos directly to your inbox. No more scattered links and email threads.',
          checklist: [],
        },
        {
          image: require('@/assets/img/features/demo-reviews/Rate.webp'),
          imageAlt: 'Review workflow',
          heading: 'Review submissions',
          body: 'Your team can listen, save, reject, rate, and comment. Everyone stays aligned on every track.',
          checklist: [],
        },
        {
          image: require('@/assets/img/features/demo-reviews/Reviews.webp'),
          imageAlt: 'Analytics',
          heading: 'Track Demo Engagement',
          body: 'Submitters are provided with comprehensive interaction data for all demo entries.',
          checklist: [],
        },
      ],
      solutionChecklist: [
        'Centralized demo inbox',
        'Fast listen workflow',
        'Team reviews',
        'Ratings and comments',
      ],
      problemColumns: [
        {
          heading: '<span class="strike">Email chaos</span>',
          body: 'Direct messages, downloads, and streaming links scattered across emails and platforms.<br>Important demos get lost.',
        },
        {
          heading: '<span class="strike">Fragmented reviews</span>',
          body: 'A&Rs, interns, and managers review demos in different places. Feedback and communication is scattered and duplicated.',
        },
        {
          heading: '<span class="strike">Demo ghosting</span>',
          body: 'Labels often receive more demos than they have the time or capacity to respond to. <br>Without simple tools, many artists never hear back.',
        },
      ],
    }
  },
  metaInfo: {
    title: 'Features — For labels',
  },
}
</script>
<style lang="scss" scoped>
@import "@/scss/_variables.scss";
.features-labels {
  --bg-color: #111;
}
.hero-overflow-wrap {
  overflow-x: hidden;
}
.inner-content {
  gap: 200px;
  padding: 200px 0;
}
</style>
